import { Component, OnInit } from '@angular/core';
import Swal from "sweetalert2";
import { Marque } from '../models/Marque.model';
import { MarqueService } from '../_services/marque.service';
@Component({
  selector: 'app-marque',
  templateUrl: './marque.component.html',
  styleUrls: ['./marque.component.css']
})
export class MarqueComponent implements OnInit {

  marques: Marque[];
  p: number = 1;
  constructor(private marqueservice: MarqueService) {}

  ngOnInit() {
    this.LoadTableMarque();
    ///////
    var pageHeader = $(".content-header").find("b");
    var adminForm = $(".admin-form");
    var buttons = adminForm.find(".button");
    var Panel = adminForm.find(".panel");
    setTimeout(function () {
      adminForm.addClass("theme-success");
      Panel.addClass("panel-success");
      pageHeader.addClass("text-success");

      buttons.removeClass().addClass("button btn-success");
    }, 800);
    //////
  }
  LoadTableMarque() {
    this.marqueservice.getData().subscribe((data: Marque[]) => {
      console.log(data);
      this.marques = data;
      console.log(this.marques);
    });
  }
  delete(id) {
    this.marqueservice.deleteData(id).subscribe(() => {
      this.LoadTableMarque();
    });
  }
  deleteSupprimer(id){
    Swal.fire({
      title: 'Suppression',
      text: "Êtes-vous sûr de vouloir supprimer.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Non, annuler !'
    }).then((result) => {
      if (result.value) {
        this.delete(id);
        Swal.fire(
          'Supprimé!',
          'Supprimé avec succès',
          'success'
        )
      }else {

      }
    })
  }

}
